<template>
    <div>
        <div class="d-flex align-items-center mt-2">
            <a @click.prevent="openModal('Handelsbetingelser', 'https://steptransport.dk/handelsbetingelser.html')"
               class="text-white mr-4"
               href="#"
            >Handelsbetingelser</a>
            <a @click.prevent="openModal('Cookie- og privatlivspolitik', 'https://steptransport.dk/privatlivspolitik.html')"
               class="text-white"
               href="#"
            >Cookie- og privatlivspolitik</a>
        </div>
        <modal-iframe ref="modal"
            :title="modalTitle"
            :src="modalSrc"
            @toggleActiveIframeModalInterval="toggleActiveIframeModalInterval"
        ></modal-iframe>
        <div v-if="activeIframeModal"
             class="modal-backdrop fade show"
        ></div>

    </div>
</template>

<script>
import modalIframe from "./reusable/ModalIframe.vue";
export default {
    name: "CmfFooter",
    components: {modalIframe},
    props: {},
    data() {
        return {
            activeIframeModal: false,
            show: false,
            modalTitle: '',
            modalSrc: '',
        }
    },
    methods: {
        toggleActiveIframeModalInterval() {
            this.activeIframeModal = !this.activeIframeModal;
        },
        openModal(title, src) {
            this.modalTitle = title;
            this.modalSrc = src;
            this.$refs["modal"].toggleModal();
        }
    }
}

</script>

<style scoped>

</style>
